import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { IdentityAPI } from '../../../config/api';
import { IBadRequestResponse } from '../../../interfaces/IBadRequestResponse';

export const getGeneralData = createAsyncThunk(
  'generalData/getGeneralData',
  async () => {
    return '';
  }
);

export const postLogin = createAsyncThunk(
  'generalData/postLogin',
  async (
    args: {
      email: string;
      password: string;
    },
    { rejectWithValue, fulfillWithValue }
  ): Promise<AxiosError<IBadRequestResponse> | any> => {
    const { email, password } = args;

    try {
      const response = await IdentityAPI.post(
        'v1/user/login',
        {
          key: email,
          password,
          controle: {
            produto: {
              _Id: 1,
            },
          },
        },
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
          },
        }
      );

      return fulfillWithValue(response.data.user);
    } catch (err: any) {
      const error = err as AxiosError<IBadRequestResponse>;
      return rejectWithValue(error);
    }
  }
);
